import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

export function setGlobalBaseUrl(baseURL) {
  axios.defaults.baseURL = baseURL;
}
